import React from "react";
import { Box, Flex, useMediaQuery } from "@chakra-ui/react";
import SideBar from "./AuthLayout/SideBar";
import SideBarr from "./NonAuthLayout/SideBarr";
import Header from "./AuthLayout/Header";

export const AuthLayout = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");

  return (
    <Box
      overflowX={isMobile ? "hidden" : ""}
      color="#000"
      bg="#fff"
      position="relative"
    >
      <Box minH="100vh" overflowX="hidden">
        <Header />
        {!isMobile && <SideBar />}
        <Box
          w="100%"
          pt="75px"
          minH="100vh"
          color="#828282"
          pl={!isMobile ? "285px" : "20px"}
          pr={!isMobile ? "50px" : "20px"}
          pb={10}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export const NonAuthLayout = ({ children }) => {
  const [isMobile] = useMediaQuery("(max-width: 991px)");

  return (
    <Box color="#000" bg="#fff" position="relative">
      <Flex minH="100vh">
        {!isMobile && <SideBarr />}
        <Box
          pt={!isMobile ? "100px" : 10}
          pl={!isMobile ? "80px" : 10}
          // pr={!isMobile ? 0 : "40px"}
          w={!isMobile ? "50%" : "100%"}
        >
          {children}
        </Box>
      </Flex>
    </Box>
  );
};
